import { useMemo } from "react";
import { BUTTON_LABELS, CONFIG_PAGES } from "@miplatform/constants";
import { useRouter } from "@miplatform/hooks";
import { IOrderTemplateResponse } from "@miplatform/types";
import { mdiChevronDown, mdiPencilOutline, mdiTrashCanOutline } from "@mdi/js";
import { useTheme } from "@mui/material";
import { CONFIG_PATHS } from "../../../../routes/config/constants";
import { ConfigCard, ConfigMenu } from "../../components";

export const ConfigOrderTemplateCard = ({
  item,
  handleOpenDeleteModal,
  updateDraftStatus,
  canDeleteOrderTemplate,
  canUpdateOrderTemplate,
}: {
  item: IOrderTemplateResponse;
  handleOpenDeleteModal: (item: IOrderTemplateResponse) => void;
  canDeleteOrderTemplate: boolean;
  canUpdateOrderTemplate: boolean;
  updateDraftStatus: (id: string, name: string, isActive: boolean) => void;
}) => {
  const theme = useTheme();
  const { navigate } = useRouter();
  const navigateToOrderTemplateDetails = () => {
    navigate(`${CONFIG_PATHS[CONFIG_PAGES.ORDER_TEMPLATES]}/${item.id}`);
  };

  const menuActions = useMemo(() => {
    const actions = [];

    if (canUpdateOrderTemplate) {
      actions.push({
        label: BUTTON_LABELS.EDIT,
        action: navigateToOrderTemplateDetails,
        icon: mdiPencilOutline,
      });
    }

    if (canDeleteOrderTemplate) {
      actions.push({
        label: BUTTON_LABELS.DELETE,
        action: () => handleOpenDeleteModal(item),
        icon: mdiTrashCanOutline,
        color: theme.palette.red.main,
      });
    }

    return actions;
  }, [canUpdateOrderTemplate, canDeleteOrderTemplate]);

  return (
    <ConfigCard
      title={item.name}
      modifiedOn={item.modifiedOn}
      additionalTitleText={[item.module]}
      createdOn={item.createdOn}
      onClick={navigateToOrderTemplateDetails}
      menuActions={menuActions}
      customAction={
        <ConfigMenu
          data={[
            {
              label: item.isActive ? "Draft" : "Activate",
              action: () => {
                updateDraftStatus(item.id, item.name, !item.isActive);
              },
            },
          ]}
          optionalElement={{
            size: "small",
            title: item.isActive ? "Active" : "Draft",
            color: item.isActive ? "success" : "orange",
            endIcon: { path: mdiChevronDown },
            sx: { width: 85 },
          }}
        />
      }
    />
  );
};
